import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaEye } from "react-icons/fa";
import './AssignHistory.css';

const AssignedUsers = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null); 
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const assignedUsers = [
    {
      id: 1,
      name: 'Adarsh',
      email: 'me@gmail.com',
      mobile: '1111111111',
      assignmentType: 'Exam',
      examType: 'POSP Exam',
      examMaster: 'POSP Mock 1',
      trainingType: '',
    },
    {
      id: 2,
      name: 'Rudra Singh',
      email: 'rudra@finhaat.com',
      mobile: '3333333333',
      assignmentType: 'Training',
      examType: '',
      examMaster: '',
      trainingType: 'POSP Training',
    },
    {
      id: 3,
      name: 'Mayur',
      email: 'mayur@finhaat.com',
      mobile: '2222222222',
      assignmentType: 'Training',
      examType: '',
      examMaster: '',
      trainingType: 'POSP Training',
    },
    {
      id: 4,
      name: 'Kunal',
      email: 'mayur@finhaat.com',
      mobile: '2222222222',
      assignmentType: 'Training',
      examType: '',
      examMaster: '',
      trainingType: 'POSP Training',
    },
  ];

  const handleSearch = (term) => {
    const lowercasedTerm = term.toLowerCase();
    const filteredResults = assignedUsers.filter(
      (user) =>
        user.name.toLowerCase().includes(lowercasedTerm) ||
        user.email.toLowerCase().includes(lowercasedTerm) ||
        user.mobile.includes(lowercasedTerm)
    );
    setFilteredData(filteredResults);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    handleSearch(value);
  };

  const customStyles = {
    headCells: {
      style: {
        fontSize: '12px',
        color: '#000',
        backgroundColor: '#e0e0e0',
        fontWeight: '550',
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.id === selectedRowId,
      style: {
        backgroundColor: 'black', 
        color: 'red',
        fontWeight: '550',
        fontSize: '13px',
      },
    },
  ];

  const columns = [
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Email Address',
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: 'Mobile Number',
      selector: (row) => row.mobile,
      sortable: true,
    },
    {
      name: 'Action',
      cell: (row) => (
        <a
          href="/#"
          className="view-more-link"
          onClick={(e) => {
            e.preventDefault();
            handleViewMore(row);
          }}
        >
          <FaEye />
        </a>
      ),
    },
  ];

  const handleViewMore = (user) => {
    setSelectedUser(user);
    setSelectedRowId(user.id); 
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedUser(null);
    setSelectedRowId(null);
  };

  return (
    <div className="assigned-users-container">
      <h2>Assigned Users</h2>
      <DataTable
        columns={columns}
        data={filteredData.length ? filteredData : assignedUsers}
        customStyles={customStyles}
        pagination
        highlightOnHover
        striped
        conditionalRowStyles={conditionalRowStyles} 
        subHeader
        subHeaderComponent={
          <input
            type="text"
            value={searchTerm}
            placeholder="Search by Name, Email or Mobile"
            className="search-input"
            onChange={handleChange}
          />
        }
      />

      {modalVisible && selectedUser && (
        <div className="assign-modal-container">
          <div className="assign-modal-content">
            <span className="assign-close-modal" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-info">
              <p><span className="modal-label">Name:</span> {selectedUser.name}</p>
              <p><span className="modal-label">Email:</span> {selectedUser.email}</p>
              <p><span className="modal-label">Mobile Number:</span> {selectedUser.mobile}</p>
              <p><span className="modal-label">Assignment Type:</span> {selectedUser.assignmentType}</p>
              {selectedUser.assignmentType === 'Exam' && (
                <>
                  <p><span className="modal-label">Exam Type:</span> {selectedUser.examType}</p>
                  <p><span className="modal-label">Exam Master:</span> {selectedUser.examMaster}</p>
                </>
              )}
              {selectedUser.assignmentType === 'Training' && (
                <p><span className="modal-label">Training Type:</span> {selectedUser.trainingType}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssignedUsers;
